export const STOP_VOICE_RECORDER_AND_UPLOAD = "stopVoiceRecorderAndUpload";
export const VOICE_RECORDER_UPLOADED = "voiceRecorderUploaded";
export const SAMPLE_INFO_CHANGED = "sampleInfoChanged";

export const REQ_CHECK_QUESTIONNAIRE = "requestForQuestionnaireCheck";
